import { Paper as CXPaper, IPaper as CXIPaper } from '@sanlamcx/react-ui-next-paper';

export type IPaper = CXIPaper;

export const Paper = CXPaper;

// This enum is redeclared here due to export issues in CX Paper package.
export declare enum PaperCOLOR {
  PRIMARY = 0,
  SECONDARY = 1,
  TERTIARY = 2,
  QUATERNARY = 3,
  GLASS = 4,
  GLASS_LIGHT = 5,
  GLASS_DARK = 6,
  NONE = 7
}
